




import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class Label extends Vue {
    @Prop({ type: [String, Number], required: false }) public text!: string | number;
}
